import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { CurrentUser } from '../../services/current-user.service';
import moment from 'moment';
const isoDateTimeFormat = 'YYYY-MM-DD[T]HH:mm:ssZ';

@Pipe({
    name: 'userDateTime',
    standalone: false
})
export class UserDateTimePipe extends DatePipe implements PipeTransform {
  constructor(public user: CurrentUser) {
    super('en-US');
  }

  transform(value: any, args?: any): any {

    if (!value) {
      return value;
    }
    
    let addTime = false;  
    value = this.user.addZeroToHours(value);
    if (args && args === 'time') {
      addTime = true;
    }
    if (this.user && this.user.dateFormats.display.dateInput) {
      if (moment(value, isoDateTimeFormat, true).isValid()) {
        return moment(value, isoDateTimeFormat, true).format(addTime ? this.user.getDateTimeFormat() : this.user.dateFormats.display.dateInput);
      }

      const defaultTime = '12:00:00 AM';
      const timeFormatLenght = defaultTime.length;
      const onlyDateProvided = value.length === this.user.dateFormats.display.dateInput.length;
      const isValidValue = value.length === this.user.dateFormats.display.dateInput.length || value.length >= (this.user.dateFormats.display.dateInput.length + ' '.length + timeFormatLenght)
      if (isValidValue) {
        if(onlyDateProvided && addTime) {
          value = `${value} ${defaultTime}`;
        }
        let format = addTime ? this.user.getDateTimeFormat() : this.user.dateFormats.display.dateInput;
        return moment(value, format, true).format(format);
      }

      return value;
    } else {
      return super.transform(value, 'dd/MM/yyyy');
    }
  }
}

